import { lowerCase } from "lodash";
import { useState } from "react";

export default function DropdownMenu({
  selectedOption,
  setSelectedOption,
  isSportTab,
  showAll,
  handleActive,
}) {
  // state for dropdown visibility
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  console.log(isSportTab, "isSportTab");
  return (
    <div className="bg-black-100 px-2 py-9px flex justify-between">
      {/* Dropdown */}
      <div className="relative z-20 flex items-center px-6px py-2 w-[114px] bg-white text-11 rounded-6px shadow-all-button">
        <i className="icon-toggle flex items-center justify-center mr-1 rotate-90 text-11" />
        <button
          className="select text-left w-full text-15"
          onClick={toggleDropdown}
        >
          <div className="flex justify-start items-center">
            <div className="w-full flex justify-start items-center">
              <span className="text-11 whitespace-nowrap">
                {selectedOption}
              </span>
            </div>
            <i
              className={`icon-triangle transform text-8 scale-75 transition-transform origin-center duration-300 mx-0.5 ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
        </button>

        {/* Dropdown options */}
        {isOpen && (
          <div className="drop-down w-full left-0 text-15 absolute top-8 -mt-1 z-10">
            <div className="options bg-white flex flex-col rounded-6p rounded-t-none whitespace-nowrap shadow-all-button">
              {["by Competition", "by Time"].map((opt, i) => (
                <p
                  key={i}
                  className="item flex items-center py-2 px-6 cursor-pointer"
                  onClick={() => handleSelect(opt)}
                >
                  <span className="item-text relative text-11">{opt}</span>
                </p>
              ))}
            </div>
          </div>
        )}
      </div>

      {isSportTab !== "all" && selectedOption != "by Time" && (
        <div
          onClick={() =>
            handleActive(
              isSportTab,
              "",
              showAll[isSportTab] == true ? false : true
            )
          }
          className="sort-Filter inline-flex items-center justify-center bg-white text-11 cursor-pointer shadow-all-button p-2 h-[26px] rounded-6 text-submenu"
        >
          <span className="mr-1">ALL</span>
          <i
            className={`icon-arrow-double mt-px sm:mt-0 text-11 text-submenu scale-75 transition-transform origin-center duration-300 transform ${
              showAll[lowerCase(isSportTab)] ? "rotate-180" : ""
            } `}
          />
        </div>
      )}
    </div>
  );
}
